// components/modals/EndowmentModals/DeleteEndowmentModal.jsx
import React from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import useModalHistory from '../../../hooks/useModalHistory';

/**
 * Modal for confirming endowment deletion
 */
export const DeleteEndowmentModal = ({ 
  show, 
  onHide, 
  endowmentName, 
  onConfirm, 
  isLoading 
}) => {
    useModalHistory(show, onHide, 'endowment-delete-modal');

  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop="static"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Delete Endowment</Modal.Title>
      </Modal.Header>
      
      <Modal.Body>
        <div className="text-center mb-4">
          <div className="warning-icon mb-3">
            <i className="fas fa-exclamation-triangle fa-3x text-danger"></i>
          </div>
          
          <h4>Are you sure?</h4>
          
          <p className="text-white">
            You are about to delete the endowment "{endowmentName}". This action cannot be undone.
          </p>
          
          <p className="font-weight-bold text-white mt-4">
            All data and access privileges associated with this endowment will be permanently removed.
          </p>
        </div>
      </Modal.Body>
      
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={isLoading}>
          Cancel
        </Button>
        <Button 
          variant="danger" 
          onClick={onConfirm}
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="mr-2"
              />
              Deleting...
            </>
          ) : (
            'Delete Endowment'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};